module.exports = __webpack_public_path__ + "static/media/product-placeholder.785ea798.png";